import { IVoiceCatalogState } from 'store/types/voiceCatalog'

export const getInitialState = (): IVoiceCatalogState => ({
  languageOptions: { data: null, isLoading: false },
  avatarLanguageOptions: { data: null, isLoading: false },
  speakersPerLangCode: null,
  speakerTones: { data: null, isLoading: false }
})
